$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // ========================
  // DROPDOWN SCRIPTS 
  // ========================
  const dropdownContainer = $('.mobile-menu-container');

  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search Website');
  $('.searchBoxInput input').val('');
  $(dropdownContainer).find('.search-container').attr('placeholder', 'Search Website');
  $('#mobileSearchInput').val('');
  $('.header .emailSignup .emailInputSubmit .button').text('');

  // Dropdown script for ticket button and containers
  $('.mobile-menu-footer-links').empty();
  $('.mobile-menu-footer-links').append(`<div class="nav-ticket"></div><div class="nav-social"></div>`);
  $('.header .ticket-container').clone().appendTo('.mobile-menu-container .nav-ticket');
  $(dropdownContainer).append('<div class="dropdown-wrap"></div>');
  $(dropdownContainer).find('.search-container').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-slider').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-footer-links').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-header').append('<div class="inner-container"></div>');
  $('.header .header-logo').clone().appendTo('.mobile-menu-container .inner-container');
  $(dropdownContainer).find('.close-mobile-menu').appendTo('.mobile-menu-container .inner-container');

  // Mobile menu toggle
  $('.mobile-nav-toggle').append('<div></div><div></div><div></div>')
  $('.mobile-nav-toggle').on('click', () => {
    $(dropdownContainer).find('.mobile-menu-slider .m-group').each(function () {
      $(this).find('.next-level-btn').empty();
    })
    $('.mobile-menu-slider').css('height','auto')
  });

  // Social icons cloning
  $('.socialNetworks').each(function () {
    $(this).find('a').clone().appendTo('.footer .cloned-social');
    $(this).find('a').clone().appendTo('.mobile-menu-container .nav-social');
  })

  // Ticket button smooth load
  $(window).load(function () {
    $('.ticket-container').css('opacity', '1');
  })

  // Ticket button behavior
  $(window).scroll(function () {
    let bodyClass = $('body').hasClass('saffireWindowScrolled');
    if (bodyClass) {
      $('.header .ticket-container').addClass('removeButton');
      $('.header .ticket-container').addClass('heightButton');

    } else {
      $('.header .ticket-container').removeClass('heightButton');
      $('.header .ticket-container').removeClass('removeButton');
    }
  });

  // ========================
  // COUNTDOWN SCRIPTS 
  // ========================
  $(window).load(function () {
    setTimeout(() => {
      $('.count-container').css('opacity', 1);
      $('.count-container').css('transform', 'none');
    }, 900);
  })

  // ========================
  // EMAIL SIGNUP SCRIPTS 
  // ========================
  $('.tier-4-container .emailSignup .emailSignupText').remove();
  $('.tier-4-container .emailSignup').prepend(`
      <div class="signup-header">
        <span class="signup-icon"></span>
        <h2>Never Miss a beat<span>Join our newsletter</span></h2>
      </div>`);

  $('.tier-4-container .signup-header').after('<div class="signup-wrap"></div>');
  $('.tier-4-container .emailInputField').appendTo('.signup-wrap');
  $('.tier-4-container .emailInputSubmit').appendTo('.signup-wrap');
  $('.tier-4-container .emailInputSubmit a').text('Sign up');
  $('.tier-4-container .signup-wrap input').attr('placeholder', 'Enter Email');
  $('.tier-4-container .signup-wrap input').val('');


  // ========================
  // MISC SCRIPTS 
  // ========================
  $(window).load(function () {
    $('.header .navMobileMenuShiftedGoBack').remove();
    $('#generalSponsors .homepageh1').remove();
  })
});
